import { ArrowRight, CheckCircle2, XCircle } from "lucide-react";
import { Reveal, SectionHead } from "./shared";

const BEFORE = [
    "Missed calls",
    "Slow responses",
    "Forgotten follow-ups",
    "Leads slipping away",
    "Manual appointment scheduling",
    "After-hours inquiries ignored",
    "No consistent review requests",
];

const AFTER = [
    "Instant responses",
    "Automatic follow-up",
    "Appointments booked",
    "Leads organized",
    "Missed-call recovery",
    "24/7 communication",
    "Automated review requests",
];

export default function BeforeAfter() {
    return (
        <section className="py-24 sm:py-32" data-testid="compare-section">
            <div className="container-x">
                <SectionHead
                    eyebrow="03 — The Shift"
                    title="What Happens When You Stop Chasing Leads?"
                    testid="compare-heading"
                />
                <div className="mt-16 grid lg:grid-cols-[1fr_auto_1fr] gap-6 items-stretch">
                    <Reveal>
                        <div className="rounded-3xl border border-red-500/15 bg-red-500/[0.04] p-8 h-full" data-testid="compare-before-card">
                            <p className="ff-mono text-xs uppercase tracking-[0.2em] text-red-400/80 mb-8">Without Automation</p>
                            <ul className="space-y-4">
                                {BEFORE.map((b, i) => (
                                    <Reveal key={b} delay={0.05 * i} y={14}>
                                        <li className="flex items-center gap-3 text-slate-400">
                                            <XCircle className="w-5 h-5 text-red-400/70 shrink-0" />
                                            <span className="text-sm sm:text-base">{b}</span>
                                        </li>
                                    </Reveal>
                                ))}
                            </ul>
                        </div>
                    </Reveal>

                    <div className="hidden lg:flex items-center justify-center">
                        <Reveal delay={0.3}>
                            <div className="w-14 h-14 rounded-full bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center">
                                <ArrowRight className="w-5 h-5 text-cyan-300" />
                            </div>
                        </Reveal>
                    </div>

                    <Reveal delay={0.15}>
                        <div
                            className="rounded-3xl border border-cyan-400/25 bg-cyan-400/[0.05] p-8 h-full relative overflow-hidden"
                            data-testid="compare-after-card"
                        >
                            <div className="absolute -top-16 -right-16 w-48 h-48 bg-cyan-400/10 blur-3xl rounded-full" />
                            <p className="ff-mono text-xs uppercase tracking-[0.2em] text-cyan-300 mb-8">With Your AI Employee</p>
                            <ul className="space-y-4">
                                {AFTER.map((a, i) => (
                                    <Reveal key={a} delay={0.15 + 0.05 * i} y={14}>
                                        <li className="flex items-center gap-3 text-white">
                                            <CheckCircle2 className="w-5 h-5 text-cyan-300 shrink-0" />
                                            <span className="text-sm sm:text-base font-medium">{a}</span>
                                        </li>
                                    </Reveal>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
